<template>
  <span v-if="chips">
    <v-chip v-if="resolutionStatus == 'OPEN'" label small color="error"> Open </v-chip>

    <v-chip v-if="resolutionStatus == 'CLEARED'" label small color="success"> Cleared </v-chip>

    <v-chip v-if="resolutionStatus == 'CLEARED_ENHANCED'" label small color="success"> Cleared (EDD) </v-chip>

    <v-chip v-if="resolutionStatus == 'ESCALATED'" label small color="error"> Escalated </v-chip>

    <v-chip v-if="resolutionStatus == 'MATCH_CONFIRMED'"> Match Confirmed </v-chip>
  </span>
  <span v-else>
    <span v-if="resolutionStatus == 'OPEN'" class="error--text font-weight-medium"> Open </span>

    <span v-if="resolutionStatus == 'CLEARED'" class="success--text font-weight-medium"> Cleared </span>

    <span v-if="resolutionStatus == 'CLEARED_ENHANCED'" class="success--text font-weight-medium"> Cleared (EDD) </span>

    <span v-if="resolutionStatus == 'ESCALATED'" class="error--text font-weight-medium"> Escalated </span>

    <span v-if="resolutionStatus == 'MATCH_CONFIRMED'" class="font-weight-medium"> Match Confirmed </span>
  </span>
</template>

<script>
export default {
  name: "ResolutionStatusChips",
  props: {
    resolutionStatus: {},
    chips: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
